import { IAlternateEmailModel } from '@Shared/models';

export const REQUEST_ALTERNATE_EMAILS = 'REQUEST_ALTERNATE_EMAILS';
export const RECEIVE_ALTERNATE_EMAILS = 'RECEIVE_ALTERNATE_EMAILS';

export class RequestAlternateEmails {
  readonly type = REQUEST_ALTERNATE_EMAILS;
}

export class ReceiveAlternateEmails {
  readonly type = RECEIVE_ALTERNATE_EMAILS;
  constructor(public emails: IAlternateEmailModel[]) {}
}

export type AlternateEmailsAction = RequestAlternateEmails | ReceiveAlternateEmails;
